import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=e599b56c"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=e599b56c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports